<template>
  <v-container fluid>
    <v-card flat class="my-5 elevation-0" height="100%">
      <v-card-title>
        <v-btn text small @click="$router.back()">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn small color="primary" @click="downloadLink(examTimetable)">
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-row>
        <v-col cols="8" offset="2">
          <v-card-text class="elevation-1 my-1">
            <pdf
              v-for="i in pageCount(file)"
              :key="i"
              style="width: 100%"
              :src="examTimetable"
              :page="i"
            />
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import pdf from "vue-pdf";
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import { helper } from "@/packages/dashboard/utils";

export default {
  name: "examTimetable",
  mixins: [FileMixin],
  components: { pdf },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Application/getStudentTimetable");
      window.document.title = "KISEB::Exam Timetable";
    });
  },
  data: function () {
    return {
      file: "",
    };
  },
  computed: {
    examTimetable() {
      return this.$store.getters["Application/appGetters"]("studentTimetable");
    },
  },
  methods: {
    timetableBase64: async function () {
      const blob = await helper.getFileBlob(this.examTimetable, "Timetable");
      return await helper.toBase64(blob);
    },
  },
  watch: {
    examTimetable() {
      if (this.examTimetable !== "") {
        this.timetableBase64().then((res) => {
          this.file = res.split(",")[1];
        });
      }
    },
  },
};
</script>

<style scoped></style>
